import { getExternalUrl } from '@common/utils/get-external-url'

const backupDevUrl = getExternalUrl()
export const ENVIRONMENT_URL = backupDevUrl
